export const FULLSTORY_ORG_ID = '14WJEV';

export function sendToAnalytics(metrics: object) {
    if (process.env.NODE_ENV !== 'production') {
    }
}